export default __webpack_public_path__ + "static/media/finalisation-image.e2abec94.png";